import TransactionTable from "../misc/TransactionTable";
import { useState } from "react";

export default function Transaction() {
    const [filters, setFilters] = useState<{ [key: string]: string }>({
        responseCode: "",
        merchantName: "",
        cardtype: "",
        paymentType: "",
        rrn: "",
        stan: "",
        search: "",
        terminalId: "",
        type: "",
        merchantId: "",
        transactionId: "",
        status: "",
        fromDate: "",
        toDate: "",
        limit: "",
    });

    const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFilters((prev) => ({ ...prev, [name]: value }));
    };

    return <TransactionTable filters={filters} onFilterChange={handleFilterChange} />
}